import { baseAPI, baseTransformResponse3 } from 'api/baseApi'
import { baseTransformResponse } from 'api/secondApi'
import { ApiResponce } from 'types'

type TGetSupportTeam = {
 designation: string
 name: string
 phone: string
 photo: string
}

export const contactUsApi = baseAPI.injectEndpoints({
 endpoints: ({ query, mutation }) => ({
  getSupportTeam: query<TGetSupportTeam[], void>({
   query: (body) => ({
    url: 'user/support_person',
    method: 'post',
    body,
   }),
   transformResponse: baseTransformResponse3,
  }),
  submitSupport: mutation<ApiResponce<any>, FormData>({
   query: (body) => ({
    url: 'user/support',
    method: 'post',
    body,
   }),
   transformResponse: (resp: any) => resp,
  }),
 }),
})

export const { useGetSupportTeamQuery, useSubmitSupportMutation } = contactUsApi
